import { render } from "./confirm-remove-preset.vue?vue&type=template&id=16bad816&lang=pug"
import script from "./confirm-remove-preset.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm-remove-preset.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__